<template>
  <a-modal v-model="visible" :title="title" :width="1200" destroyOnClose class="month-detail-modal">
    <TableList
      style="width: 100%; margin-top: 5px"
      :columns="columns"
      :tableData="dataSource"
      :loading="loading"
      :scroll="{}"
      :pagination="ipagination"
      @change="handleTableChange"
    >
      <!--透传列插槽：columns 中声明了 scopedSlots.customRender 的列可通过同名插槽自定义渲染-->
      <template
        v-for="slotName in dynamicSlotNames"
        :slot="slotName"
        slot-scope="text, record"
      >
        <slot :name="slotName" :text="text" :record="record">{{ text }}</slot>
      </template>
    </TableList>
    <div slot="footer" class="flex-between">
      <a-button icon="export" :loading="exportXlsLoading" @click="handleExportXls(title)">
        导出名单
      </a-button>
      <a-button type="primary" @click="hideModal">确定</a-button>
    </div>
  </a-modal>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import TableList from '@comp/chart/TableList.vue'
export default {
  name: 'DetailModal',
  mixins: [JeecgListMixin],
  components: {
    TableList,
  },
  props: {
    title: {
      type: String,
      default: '再次提醒',
    },
    columns: {
      type: Array,
      default: () => [],
    },
    url: {
      type: Object,
      default: () => ({
        // list: '/schoolEvaluationRecord/list',
        // exportXlsUrl: '/schoolEvaluationRecord/exportXls',
      }),
    },
  },
  data() {
    return {
      visible: false,
      disableMixinCreated: true,
    }
  },
  computed: {
    // 提取 columns 中声明的自定义渲染插槽名
    dynamicSlotNames() {
      return this.columns
        .filter((col) => col.scopedSlots && col.scopedSlots.customRender)
        .map((col) => col.scopedSlots.customRender)
    },
  },
  methods: {
    showModal(data) {
      this.queryParam = data
      this.loadData(1)
      this.visible = true
    },
    hideModal() {
      this.visible = false
    },
  },
}
</script>
<style scoped lang="less">
.month-detail-modal {
  /deep/ .ant-modal-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  /deep/ .ant-modal-body {
    min-height: 590px;
    padding: 10px 24px;
  }
  /deep/ .ant-modal-footer {
    padding-top: 0;
    padding-bottom: 16px;
    border-top: none;
  }
}
</style>
